module.exports = __webpack_public_path__ + "img/blockchain_industry_03@2x.86c6ad8a.png";